var ToolbarItemType = /* @__PURE__ */ function(ToolbarItemType2) {
  ToolbarItemType2["Toggle"] = "toggle";
  ToolbarItemType2["Dropdown"] = "dropdown";
  ToolbarItemType2["DropdownSeparator"] = "dropdown-separator";
  ToolbarItemType2["Button"] = "button";
  ToolbarItemType2["Custom"] = "custom";
  ToolbarItemType2["Selector"] = "selector";
  return ToolbarItemType2;
}({});

export { ToolbarItemType };
//# sourceMappingURL=toolbar.types.js.map
